import { Logger } from '~~/helpers/logger';

import type { ShippingMethodsResponse } from '~~/types/checkout/ShippingMethod';
import { errorToString } from '~~/helpers/error/errorToString';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~~/constants/routes';
import { useShippingProvider } from '~/utils/ct';

export default () => {

  const loading = ref(false);
  const shippingMethodsDataKey = 'shipping-methods-data-key';
  // const { $cache } = useNuxtApp();
  const { cart } = useCartExtended();
  const { makeCommercetoolsRequest } = useExpondoMiddleware();
  const methodsWithoutId = useState<ShippingMethodsResponse['shippingMethods']>(shippingMethodsDataKey, () => []);
  const {
    state,
    load,
  } = useShippingProvider();
  const selectedShippingMethod = computed(
    () => state?.value?.response?.shippingMethod);

  const error = reactive<{
    loadMethods: null | string | Error;
    selectShippingMethod: null | string | Error;
    loadMethodsWithoutId: null | string | Error;
  }>({
    loadMethods: null,
    selectShippingMethod: null,
    loadMethodsWithoutId: null,
  });

  const loadProviderIfNeeded = async () => {

    if (cart.value && !state.value) {

      await load();
    
    }
  
  };

  onMounted(async () => {

    await loadProviderIfNeeded();
  
  });

  const loadMethodsWithoutId = async () => {

    if (methodsWithoutId.value?.length) {

      return;

    }

    error.loadMethodsWithoutId = null;
    try {

      let shippingMethods; // = await $cache.data.get(shippingMethodsDataKey);

      if (!shippingMethods) {

        shippingMethods = await makeCommercetoolsRequest<unknown>({
          endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_SHIPPING_METHODS_WITHOUT_ID,
        });
        // await $cache.data.set(shippingMethodsDataKey, shippingMethods, [shippingMethodsDataKey]);
      
      }

      methodsWithoutId.value = shippingMethods?.data?.shippingMethods;
    
    } catch (err: unknown) {

      Logger.error('error.loadMethodsWithoutId = true ', errorToString(err));
      error.loadMethodsWithoutId = errorToString(err);
    
    }
  
  };

  const isShippingSelected = computed(() => !!selectedShippingMethod.value?.zoneRates);

  return {
    isShippingSelected,
    loading,
    error,
    loadMethodsWithoutId,
    methodsWithoutId,
    selectedShippingMethod,
  };

};
